var m = require('mithril');
var eventPresentation = require('../eventPresentation');

function renderMetaRow(label, value) {
  if (!value) return null;
  return m('div.f6.mt2', [
    m('span.moon-gray.mr1', label + ':'),
    m('span', { style: { fontWeight: 400 } }, value)
  ]);
}

module.exports = {
  view: function (vnode) {
    var eventRecord = vnode.attrs && vnode.attrs.eventRecord;
    if (!eventRecord) return null;

    var reportName = eventPresentation.getEventReportName(eventRecord);
    var reportLocationPath = eventPresentation.getDisplayEventLocationPath(
      eventRecord,
      vnode.attrs && vnode.attrs.contextLocation
    );
    var relativeTimeLabel = eventPresentation.buildRelativeEventTimeLabel(
      eventRecord.start,
      vnode.attrs && vnode.attrs.referenceMoment
    );
    var durationLabel = eventPresentation.buildDurationLabel(eventRecord.start, eventRecord.end);
    var startLabel = eventPresentation.formatEventDate(eventRecord.start, vnode.attrs && vnode.attrs.timezone);
    var endLabel = eventPresentation.formatEventDate(eventRecord.end, vnode.attrs && vnode.attrs.timezone);

    return m('div.mt3.pa3.bg-near-black.ba.b--white-10.br2', [
      vnode.attrs && vnode.attrs.title
        ? m('div.light-silver.f6.ttc.tracked.mb2', vnode.attrs.title)
        : null,
      reportName ? m('div.white', reportName) : null,
      reportLocationPath ? m('div.f6.mt1.moon-gray', reportLocationPath) : null,
      relativeTimeLabel ? m('div.f6.mt1.silver', relativeTimeLabel) : null,
      renderMetaRow('Start', startLabel),
      renderMetaRow('End', endLabel),
      durationLabel ? renderMetaRow('Duration', durationLabel) : null
    ]);
  }
};
